// write a hooks skeleton

import { getLenderInfoApi } from '@app/screens/DigioMandate/digioMandateSignService';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { RootState } from '@app/store/newstore';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { useCallback, useEffect, useState } from 'react';



export const useLenderInfo = () => {

    const [lenderInfo, setLenderInfo] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const userDetails = useAppSelector((state: RootState) => state.auth.userDetails);
    const dispatch = useAppDispatch();


    const getLenderInfoData = useCallback(async () => {
        setIsLoading(true);
        try {
          const response = await getLenderInfoApi({ applicationId: userDetails?.linkedApplications[0]?.applicationId });
          setLenderInfo(response);
        } catch (error: any) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
      }, [userDetails]);

    useEffect(() => {
        getLenderInfoData();
    }, [getLenderInfoData]);

    return { lenderInfo, isLoading };
}
